import { isTabletView } from '@/modules/globals'

export function updateAgreementsPosition (agreements, signSection) {
  const bigImg = signSection.querySelector('.bigImage')
  const imgWidth = bigImg ? -bigImg.clientWidth : 0
  const popupSignSectionHeight = signSection.clientHeight

  agreements.style.left = isTabletView() ? `${imgWidth}px` : '0px'
  agreements.style.top = `${popupSignSectionHeight + 5}px`
}


// WEBPACK FOOTER //
// ./src/components/newsletter/shared.js